<template lang="pug">
.button-wrapper
  button(type="button", v-on="$listeners").button ギグベースを始める
</template>

<script>
import {defineComponent} from "vue";

export default defineComponent({
  name: "FloatingBeginButton"
})
</script>

<style scoped lang="scss">
.button-wrapper {
  position: fixed;
  left: 0;
  bottom: 0;

  width: 100%;
  padding: 0 40px 62px;
}

.button {
  background-color: #F94848;
  color: white;

  border-radius: 60px;
  border: none;

  font-size: 14px;
  font-weight: 500;

  width: 100%;
  padding: 18px 0;
}
</style>
